import axios from "axios";

export function ensureApiBase(url?: string): string {
  let base = (url || "").trim();
  if (!base && typeof window !== "undefined") {
    base = `${window.location.origin}/api`;
  }
  if (!base) {
    base = "/api";
  }
  if (!/\/api\/?$/i.test(base)) {
    base = base.replace(/\/+$/, "") + "/api";
  }
  return base;
}

export const API_BASE_URL = ensureApiBase(process.env.VUE_APP_API_BASE_URL);

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: "application/json",
  },
  timeout: 10000, // 10 second timeout
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setupInterceptors(router: any) {
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        router.push("/login");
      }
      return Promise.reject(error);
    }
  );
}

export default apiClient;
